(() => {
  'use strict';

  if (window.manikaCartProviderInitialized) return;
  window.manikaCartProviderInitialized = true;
  // Adoric v4 turns es-MX into ES_MX, which Shopify Storefront rejects.
  // Run before its deferred bundle; preserve regional copy under the ES alias.
  const adoric = window.__ADORIC_CART_DRAWER__;
  if (adoric?.localization?.language?.toLowerCase() === 'es-mx') {
    try {
      const settingsNode = document.getElementById('cart-drawer-settings');
      if (settingsNode?.textContent) {
        const settings = JSON.parse(settingsNode.textContent);
        const regional = settings.translations?.filter(entry => entry.locale?.toLowerCase() === 'es-mx');
        if (regional?.length) {
          settings.translations.push(...regional.map(entry => ({...entry, locale: 'es'})));
          settingsNode.textContent = JSON.stringify(settings);
        }
      }
      adoric.localization.language = 'es';
    } catch {
      // Invalid app settings must not prevent the theme's cart fallback.
    }
  }

  const root = document.documentElement;
  const boundDrawers = new WeakSet();
  let lastTrigger = null;

  // Adoric's embed owns /cart/add interception. Its READY flag is set before
  // initialization; require the mounted drawer, not just the downloaded asset.
  const getAdapter = () => {
    const preference = root.dataset.rptlCartProvider || 'auto';
    if ((preference === 'auto' || preference === 'adoric')
      && !window.__ADORIC_CART_DRAWER_FAILED__
      && document.querySelector('adoric-cart-drawer')) {
      return {
        name: 'adoric',
        open: () => document.dispatchEvent(new Event('adoric-cart-drawer:open')),
      };
    }
    if ((preference === 'auto' || preference === 'rebuy')
      && document.querySelector('#rebuy-cart')
      && typeof window.Rebuy?.SmartCart?.show === 'function') {
      return {name: 'rebuy', open: () => window.Rebuy.SmartCart.show()};
    }
    return null;
  };

  const openApp = (afterProductAdded = false) => {
    const adapter = getAdapter();
    root.dataset.rptlActiveCart = adapter?.name || 'native';
    if (!adapter) return false;
    try {
      const drawer = document.querySelector('cart-drawer');
      if (drawer?.cartDrawerIsOpen) drawer.closeCartDrawer();
      // Adoric already opens on successful /cart/add; never add or open twice.
      if (!(afterProductAdded && adapter.name === 'adoric')) adapter.open();
      return true;
    } catch {
      root.dataset.rptlActiveCart = 'native';
      return false;
    }
  };

  const openNative = () => {
    root.dataset.rptlActiveCart = 'native';
    const drawer = document.querySelector('cart-drawer');
    if (typeof drawer?.openCartDrawer !== 'function') return false;
    drawer.openCartDrawer();
    return true;
  };

  const bindNativeDrawer = () => {
    const drawer = document.querySelector('cart-drawer');
    if (!drawer || boundDrawers.has(drawer)
      || typeof drawer.openCartDrawerOnProductAdded !== 'function') return;
    const nativeAdded = drawer.openCartDrawerOnProductAdded;
    document.removeEventListener('theme:product:added', nativeAdded);
    // Keep Broadcast's lifecycle property: disconnectedCallback removes this
    // wrapper and reconnecting the element reuses it without leaked listeners.
    drawer.openCartDrawerOnProductAdded = (event) => {
      if (!openApp(true)) nativeAdded.call(drawer, event);
    };
    document.addEventListener('theme:product:added', drawer.openCartDrawerOnProductAdded);
    boundDrawers.add(drawer);
  };

  const init = () => {
    bindNativeDrawer();
    window.customElements?.whenDefined('cart-drawer').then(bindNativeDrawer);
  };

  document.addEventListener('click', (event) => {
    if (event.button !== 0 || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
    const trigger = event.target instanceof Element ? event.target.closest('[data-rptl-cart-trigger]') : null;
    if (!trigger) return;
    // Leave the real /cart href usable when neither app nor drawer can open.
    if (!openApp() && !openNative()) return;
    lastTrigger = trigger;
    event.preventDefault();
    event.stopImmediatePropagation();
  }, true);

  for (const name of ['theme:cart-drawer:show', 'theme:cart:toggle']) {
    document.addEventListener(name, (event) => {
      if (!openApp()) return;
      event.preventDefault();
      event.stopImmediatePropagation();
    }, true);
  }

  document.addEventListener('rebuy:smartcart.hide', () => {
    if (root.dataset.rptlActiveCart !== 'rebuy' || !lastTrigger?.isConnected) return;
    lastTrigger.focus({preventScroll: true});
    lastTrigger = null;
  });
  document.addEventListener('shopify:section:load', init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once: true});
  else init();
})();
